import axios from 'axios';

export default async function updateUserProfile({
  accessToken,
  id,
  updateProfileData,
  setTokenLikeExpired = null,
  feedbackMessage = null,
  isLoading = null,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    if (feedbackMessage) feedbackMessage('Atualizando Informações Pessoais...', { variant: 'warning' });
    if (isLoading) isLoading(true);

    const { data } = await axios.put(
      `${process.env.REACT_APP_AUTH_API_URL}/updateProfile/${id}`,
      updateProfileData,
      requestOptions,
    );

    if (feedbackMessage) feedbackMessage('Informações Pessoais Atualizadas', { variant: 'success' });

    return data;
  } catch (err) {
    if (feedbackMessage) feedbackMessage('Não foi possível atualizar as informações, tente novamente.', { variant: 'error' });

    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  } finally {
    if (isLoading) isLoading(false);
  }
}
